var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBoxBadge = function SvgBoxBadge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "61px",
    viewBox: "0 0 45 61",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "box_icons8-maneggiare-con-cura copy 3")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elenco-Piatti/Ricette/Ristoranti",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "utente_loggato_men\\xF9",
    transform: "translate(-1591.000000, -1579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-6",
    transform: "translate(840.000000, 1579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-maneggiare-con-cura-copy-3",
    transform: "translate(751.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L45,0 L45,61 C30,51.1975519 22.5,46.2963278 22.5,46.2963278 C22.5,46.2963278 15,51.1975519 0,61 L0,0 Z",
    id: "Path-5-Copy-12",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4C058",
    fillRule: "nonzero",
    points: "8 36.627027 8 18.0108108 23 14 38 18.0108108 38 36.627027 23 42"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4C058",
    fillRule: "nonzero",
    points: "38 37.0553746 23 42 23 20.5732899 38 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F5CE7F",
    fillRule: "nonzero",
    points: "23 23 8 18.293578 23 14 38 18.293578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6227696,27 C29.3883474,27 29.1539253,26.7473788 29.0367142,26.4105505 C28.9195031,25.9895152 29.0953197,25.4842727 29.3883474,25.3158586 L32.2014137,24.0527525 C32.4944415,23.8843384 32.8460747,24.1369596 32.9632858,24.557995 C33.0804969,24.9790303 32.9046803,25.4842727 32.6116526,25.6526869 L29.7985863,26.9157929 C29.7399807,26.9157929 29.6813752,27 29.6227696,27 Z",
    id: "Path",
    fill: "#805F1D",
    fillRule: "nonzero"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoxBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/boxBadge.ea63f4f7.svg";
export { ForwardRef as ReactComponent };